export const getItemFromStore = (key: string, defaultValue: any, store = localStorage): any|undefined => {
  const item = store.getItem(key);
  return item === null ? undefined : JSON.parse(item) || defaultValue;
}

export const setItemToStore = (key: string, payload: any, store = localStorage) => 
  store.setItem(key, JSON.stringify(payload));
  